let requestIncrementor = 0;

class AbortControllerService {
  private apiController: {
    [id: number]: AbortControllerRequest;
  } = {};

  public abortPendingGetProductsRequests = async (requestCategory: string): Promise<void> => {
    Object.keys(this.apiController).forEach((id) => {
      const request: AbortControllerRequest = this.apiController[id];
      const isRequestPending = request?.requestCategory === requestCategory && request.isPending;
      if (isRequestPending) {
        request.controller.abort();
        request.isPending = false;
      }
    });

    await Promise.resolve();
  };

  public trackRequest = (requestCategory: string): AbortControllerRequest => {
    const aborter = this.createController();
    requestIncrementor = requestIncrementor + 1;
    const signalId = requestIncrementor;
    this.apiController[signalId] = { isPending: true, controller: aborter, id: signalId, requestCategory };
    return this.apiController[signalId];
  };

  public createController(): AbortController {
    return new window.AbortController();
  }
}
export interface AbortControllerRequest {
  isPending: boolean;
  controller: AbortController;
  id: number;
  requestCategory: string;
}

export const abortControllerService = new AbortControllerService();
